module.exports = __webpack_public_path__ + "static/media/parent-high-school-career.d1dbb838.jpg";